import { preserveThemePreview } from './carben-web-preview.js';

preserveThemePreview(document, window);
const menuToggle = document.querySelector('[data-menu-toggle]');
const nav = document.getElementById('site-nav');
menuToggle?.addEventListener('click', () => {
  const open = menuToggle.getAttribute('aria-expanded') !== 'true';
  menuToggle.setAttribute('aria-expanded', String(open));
  nav?.classList.toggle('is-open', open);
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.nav-group[open]').forEach(details => details.removeAttribute('open'));
    if (menuToggle?.getAttribute('aria-expanded') === 'true') {
      menuToggle.setAttribute('aria-expanded', 'false');
      nav?.classList.remove('is-open');
      menuToggle.focus();
    }
  }
});

const privacyPreferences = document.querySelector('[data-carben-privacy-preferences]');
function revealPrivacyPreferences() {
  if (privacyPreferences && typeof window.privacyBanner?.showPreferences === 'function') privacyPreferences.hidden = false;
}
privacyPreferences?.addEventListener('click', () => window.privacyBanner?.showPreferences?.());
revealPrivacyPreferences();
document.addEventListener('visitorConsentCollected', revealPrivacyPreferences);
window.addEventListener('load', revealPrivacyPreferences, { once: true });
